// extracted by mini-css-extract-plugin
export default {"container":"input_container__gWm0O","input":"input_input__bSVm8","label":"input_label__Kv6EM"};